import { render } from "./Falha.vue?vue&type=template&id=3555d17c&scoped=true"
import script from "./Falha.vue?vue&type=script&lang=js"
export * from "./Falha.vue?vue&type=script&lang=js"

import "./Falha.vue?vue&type=style&index=0&id=3555d17c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3555d17c"]])

export default __exports__